import { StorageIcon } from "@/assets/icons";
import { Button } from "@/components/ui/button";
import { DialogTrigger } from "@/components/ui/dialog";

import { PlusIcon } from "lucide-react";

interface EmptyStateProps {
  title?: string;
  description?: string;
  buttonText?: string;
  testId?: string;
  isCreateDatasetGranted?: boolean;
}

/**
 * Empty state component for when no datasets are available
 */
export default function EmptyState({
  title = "No Datasets Available",
  description = "Upload a dataset to get started.",
  buttonText = "Upload Dataset",
  testId = "no-dataset-state",
  isCreateDatasetGranted = true
}: EmptyStateProps) {
  return (
    <div
      className="flex flex-col items-center justify-center h-full text-center text-sm text-dim-gray my-auto"
      data-testid={testId}
    >
      <StorageIcon className="fill-light-gray w-8 h-8" />
      <p className="text-txtPlaceholder text-sm font-semibold">{title}</p>
      <p className="text-txtPlaceholder text-xs">{description}</p>

      {isCreateDatasetGranted && (
        <DialogTrigger asChild data-testid="no-dataset-upload-button">
          <Button variant="default" className="font-semibold rounded-xl my-4">
            <PlusIcon size={16} className="mr-2" />
            {buttonText}
          </Button>
        </DialogTrigger>
      )}
    </div>
  );
}
